import { createContext } from "../util/create-context.js";
export const [StepperContextProvider, useStepperContext] = createContext({
    hookName: "useStepperContext",
    providerName: "StepperContextProvider",
    name: "StepperContext",
    errorMessage: "<Stepper.Step> has to be used within <Stepper>",
});
//# sourceMappingURL=context.js.map